import { type FC } from "react";
import { HouseIcon, CompassIcon, FlagIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import Text from "@/components/Text";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

const BASE_NAV_ITEM =
  "flex items-center w-full gap-[8px] p-[8px] rounded-[8px] hover:bg-[#E0E0E0] active:bg-[#C6C6C6]";

const styleNavLink = (isOpen: boolean): string => {
  const styleIfNavLinkIsOpen = isOpen
    ? cn(BASE_NAV_ITEM, "inline-flex")
    : cn(BASE_NAV_ITEM, "hidden sm:inline-flex");

  return styleIfNavLinkIsOpen;
};

type Props = {
  openNav: boolean;
  onCloseNav: () => void;
};

const Nav: FC<Props> = ({ openNav, onCloseNav }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "overflow-hidden z-50 w-0 sm:w-[218px] sm:min-w-[218px] h-dvh bg-[white] sm:px-[12px] sm:py-[16px] shadow-(--boxshadow-nav) transition-(--transition-nav) sm:transition-none fixed top-(--height-header) sm:top-0 left-0 sm:relative",
        openNav ? "w-full px-[12px] py-[16px]" : "",
      )}
    >
      <img
        alt="krunsh logo"
        src="/svg/krunsh-logo.svg"
        className="hidden sm:block"
      />
      <nav className="flex flex-col mt-[40px] gap-[8px]">
        <Link to={"sign-up"}>
          <button onClick={onCloseNav} className={styleNavLink(openNav)}>
            <HouseIcon width={24} height={24} color="#758195" />
            <Text fontWeight={600} fontSize={14} color="#44546F">
              {t("home")}
            </Text>
          </button>
        </Link>
        <Link to={"sign-up"}>
          <button
            onClick={() => {
              onCloseNav();
            }}
            className={styleNavLink(openNav)}
          >
            <CompassIcon width={24} height={24} color="#758195" />
            <Text fontWeight={600} fontSize={14} color="#44546F">
              {t("explorer")}
            </Text>
          </button>
        </Link>
        <Link
          onClick={() => {
            onCloseNav();
          }}
          className={styleNavLink(openNav)}
          to="sign-up"
        >
          <FlagIcon width={24} height={24} color="#758195" />
          <Text fontWeight={600} fontSize={14} color="#44546F">
            {t("my_stores")}
          </Text>
        </Link>

        <Link to={"sign-up"}>
          <button
            onClick={() => {
              onCloseNav();
            }}
          >
            <Button variant="primaryOutlined">{t("add_my_stores")}</Button>
          </button>
        </Link>
      </nav>
    </div>
  );
};

export default Nav;
